import eventBus from '../../vue-functions/event-bus';

function resetSpecialOffersFlag() {
  eventBus.$emit('reset-special-offers-flag');
  this.$data.settings.filters.tags = [];
  this.$data.settings.filtersValues.tags = [];
  this.$data.settings.tags = '';
}
export default resetSpecialOffersFlag;
